import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/_top',
      name: 'Main',
      component: () => import('./views/page/Main.vue'),
      children: [
          {
              path: '',
              component: () => import('./views/page/TopSample.vue'),
              meta: {
                  title: 'HOME',
                  pankuzu: [],
              },
          },
      ],
    },
    {
      path: '/',
      name: 'Main',
      component: () => import('./views/page/TopPage.vue'),
      meta: {
        title: '商品をめぐる旅のはじまり｜STORY PLANET',
        pankuzu: ['トップページ'],
        description: 'ここはSTORY PLANET（ストーリープラネット）【新しいなにか】と出会う冒険のはじまり｜「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
        keyword: 'ストーリープラネット,storyplanet,EC,通販,冒険',
      },
    },
    {
      path: '/item/list/:store_url',
      name: 'Main',
        component: () => import('./views/page/Main.vue'),
        children: [
          {
            path: '',
            component: () => import('./views/page/ItemList.vue'),
            meta: {
              // ここのTDKはページ内で書き換える
              title: '商品一覧',
              pankuzu: ['商品一覧'],
              description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
              keyword: '買い物,新しい,EC,イラスト,商品,冒険',
            },
          },
        ],
      },
    {
      path: '/item/detail',
      name: 'Main',
      component: () => import('./views/page/Main.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/ItemDetail.vue'),
          meta: {
            title: '商品詳細',
            pankuzu: ['商品詳細'],
            description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
            keyword: '買い物,新しい,EC,イラスト,商品,冒険',
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'Main',
      component: () => import('./views/page/Main.vue'),
      children: [
          {
              path: '',
              component: () => import('./views/page/Login.vue'),
              meta: {
                  title: 'LOGIN',
                  pankuzu: ['LOGIN'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
          {
              path: 'cart',
              component: () => import('./views/page/Login.vue'),
              meta: {
                  title: 'LOGIN',
                  pankuzu: ['LOGIN'],
                  history: 'cart',
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
          {
              path: 'password',
              component: () => import('./views/page/PasswordReset.vue'),
              meta: {
                  title: 'パスワード再発行',
                  pankuzu: ['パスワード再発行'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
          {
              path: 'password/end',
              component: () => import('./views/page/PasswordResetEnd.vue'),
              meta: {
                  title: 'パスワード再発行',
                  pankuzu: ['パスワード再発行'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
      ],
    },
    {
      path: '/mypage',
      name: 'Main',
      component: () => import('./views/page/Main.vue'),
      children: [
          {
              path: '',
              component: () => import('./views/page/MyPage.vue'),
              meta: {
                  title: 'マイページ',
                  pankuzu: ['マイページ'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
          {
              path: 'add_sender',
              component: () => import('./views/page/AddSender.vue'),
              meta: {
                  title: 'お届け先の追加',
                  pankuzu: ['お届け先の追加'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
          {
              path: 'edit_sender',
              component: () => import('./views/page/EditSender.vue'),
              meta: {
                  title: 'お届け先の変更',
                  pankuzu: ['お届け先の変更'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
          {
              path: 'order_history',
              component: () => import('./views/page/OrderHistory.vue'),
              meta: {
                  title: '購入履歴',
                  pankuzu: ['購入履歴'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
          {
              path: 'point_history',
              component: () => import('./views/page/PointHistory.vue'),
              meta: {
                  title: 'ポイント履歴',
                  pankuzu: ['ポイント履歴'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
          {
              path: 'point_history/:page',
              component: () => import('./views/page/PointHistory.vue'),
              meta: {
                  title: 'ポイント履歴',
                  pankuzu: ['ポイント履歴'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
          {
              path: 'order_end',
              component: () => import('./views/page/OrderEnd.vue'),
              meta: {
                  title: '購入履歴',
                  pankuzu: ['購入履歴'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
          {
              path: 'order/detail',
              component: () => import('./views/page/OrderDetail.vue'),
              meta: {
                  title: '購入履歴詳細',
                  pankuzu: ['購入履歴', '履歴詳細'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
      ],
    },
    {
      path: '/eitokuen',
      name: 'Main',
      component: () => import('./views/page/Mizunasu.vue'),
      meta: {
        title: 'ジュワッとおいしい永徳園の水なす｜STORY PLANET',
        pankuzu: ['永徳園'],
        description: 'ジュワッとおいしい水なすがみんなのところに届くまでの流れを、水なすの魅力と共にお届けします。【大阪岸和田の永徳園】ナス兄が育てる水なすは安心・安全で食べて感動するおいしさ！徹底した品質管理のもと元気に育った水なすをどうぞ召し上がれ。',
        keyword: '水なす,大阪,魅力,おいしい,永徳園',
      },
    },
    {
      path: '/chaoras',
        name: 'Main',
        component: () => import('./views/page/Tenugui.vue'),
        meta: {
          title: 'CHAORAS®スポーツてぬぐい｜STORY PLANET',
          pankuzu: ['CHAORAS'],
          description: '実用性とデザイン性を兼ね備えた新しいてぬぐい、CHAORAS®の【スポーツてぬぐい】宮本さんが、普通のてぬぐいとの違いや、肌当たりがよく、やわらかいスポーツてぬぐいの特徴や豆知識を紹介してくれるよ。てぬぐいができるまでの工程も必見です。',
          keyword: 'チャオラス,手ぬぐい,てぬぐい,スポーツ,やわらかい',
        },
    },
    {
      path: '/afurikadogs',
        name: 'Main',
        component: () => import('./views/page/Afrikadogs.vue'),
        meta: {
          title: 'AFURIKA DOGSポロシャツ・染め体験｜STORY PLANET',
          pankuzu: ['AFURIKA DOGS'],
          description: 'AFURIKA DOGS（アフリカドッグス）では、手織りのアフリカ布や京都の染色技術を生かした生地を使い、ここにしかない服や小物を作り機械では出せない繊細な味わいを届けています。彩纈染めのポロシャツや、世界で一着の服をつくる染め工房体験の魅力をご紹介します。',
          keyword: 'アフリカドッグス,アフリカ布,染め体験,伝統,手仕事',
        },
    },
    {
      path: '/kuntama',
        name: 'Main',
        component: () => import('./views/page/Kuntama.vue'),
        meta: {
          title: 'くんたま王子 燻らのたまご｜STORY PLANET',
          pankuzu: ['くんたま王子'],
          description: '昔ながらの伝統製法でひとつひとつ手間ひまかけて作られる、くんたま王子の"燻らのたまご”。このページでは、くんたま王子がお届けする"燻らのたまご"のこだわりの伝統製法やおいしさの秘訣、アレンジレシピなどをご紹介しています。',
          keyword: 'くんたま王子,燻製,燻製たまご,伝統製法',
        },
    },
    {
      path: '/cart',
      name: 'Main',
      component: () => import('./views/page/Main.vue'),
      children: [
        {
          path: '',
          component: () => import('./views/page/Cart.vue'),
          meta: {
            title: 'ショッピングカート',
            pankuzu: ['カート'],
            description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
            keyword: '買い物,新しい,EC,イラスト,商品,冒険',
          },
        },
      ],
    },
    {
      path: '/regi',
      name: 'Main',
      component: () => import('./views/page/Main.vue'),
      children: [
          {
              path: '',
              component: () => import('./views/page/Regi.vue'),
              meta: {
                  title: 'お届け先・配送方法・お支払い方法',
                  pankuzu: ['ショッピングカート', 'お届け先・配送方法・お支払い方法'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
          {
              path: 'confirm',
              component: () => import('./views/page/RegiConfirm.vue'),
              meta: {
                  title: 'お届け先・配送方法・お支払い方法確認',
                  pankuzu: ['ショッピングカート', 'お届け先・配送方法・お支払い方法確認'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
          {
              path: 'end',
              component: () => import('./views/page/RegiEnd.vue'),
              meta: {
                  title: 'ご購入完了',
                  pankuzu: ['ショッピングカート', 'ご購入完了'],
                  description: 'ここはSTORY PLANET【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY PLANETで商品をめぐる旅に、でかけよう！',
                  keyword: '買い物,新しい,EC,イラスト,商品,冒険',
              },
          },
      ],
    },
    {
      path: '/user',
      name: 'Main',
      component: () => import('./views/page/Main.vue'),
      children: [
        {
            path: 'append',
            component: () => import('./views/page/UserAppend.vue'),
            meta: {
                title: '新規会員登録｜STORY PLANET',
                pankuzu: ['会員登録'],
                description: 'STORY PLANETの新規会員登録ページです。【STORY PLANET】は、株式会社STORYが運営するウェブサイトです。',
                keyword: '新規会員登録,会員登録,STORY',
            },
        },
        {
          path: 'confirm',
          component: () => import('./views/page/UserConfirm.vue'),
            meta: {
                title: '会員情報確認',
                pankuzu: ['会員情報確認'],
                description: 'STORY PLANETの新規会員登録ページです。【STORY PLANET】は、株式会社STORYが運営するウェブサイトです。',
                keyword: '新規会員登録,会員登録,STORY',
            },
        },
        {
          path: 'edit',
          component: () => import('./views/page/UserEdit.vue'),
            meta: {
                title: '会員情報変更',
                pankuzu: ['会員情報変更'],
                description: 'STORY PLANETの新規会員登録ページです。【STORY PLANET】は、株式会社STORYが運営するウェブサイトです。',
                keyword: '新規会員登録,会員登録,STORY',
            },
        },
        {
          path: 'password',
          component: () => import('./views/page/Password.vue'),
            meta: {
                title: 'パスワードの変更',
                pankuzu: ['パスワードの変更'],
                description: 'STORY PLANETの新規会員登録ページです。【STORY PLANET】は、株式会社STORYが運営するウェブサイトです。',
                keyword: '新規会員登録,会員登録,STORY',
            },
        },
        {
          path: 'password/end',
          component: () => import('./views/page/PasswordEnd.vue'),
            meta: {
                title: 'パスワードの変更',
                pankuzu: ['パスワードの変更'],
                description: 'STORY PLANETの新規会員登録ページです。【STORY PLANET】は、株式会社STORYが運営するウェブサイトです。',
                keyword: '新規会員登録,会員登録,STORY',
            },
        },
      ]
    },
    {
      path: '/contents',
      name: 'Main',
      component: () => import('./views/layout/ContentLayout.vue'),
      children: [
          {
              path: 'inquiry',
              component: () => import('./views/page/Inquiry.vue'),
              props: true,
              meta: {
                  title: 'お問い合わせ｜STORY PLANET',
                  pankuzu: ['お問い合わせ'],
                  description: 'STORY PLANETへのお問い合わせページです。お問い合わせはフォームより受け付けをしております。フォームに必要な情報を入力後「確認」ボタンよりご確認の上「送信」お願いします。',
                  keyword: 'お問い合わせ,問合せ,フォーム',
              },
          },
          {
              path: 'inquiry/confirm',
              component: () => import('./views/page/InquiryConfirm.vue'),
              meta: {
                  title: 'お問い合わせ確認',
                  pankuzu: ['お問い合わせ確認'],
                  description: 'STORY PLANETへのお問い合わせページです。お問い合わせはフォームより受け付けをしております。フォームに必要な情報を入力後「確認」ボタンよりご確認の上「送信」お願いします。',
                  keyword: 'お問い合わせ,問合せ,フォーム',
              },
          },
          {
              path: 'inquiry/end',
              component: () => import('./views/page/InquiryEnd.vue'),
              meta: {
                  title: 'お問い合わせ完了',
                  pankuzu: ['お問い合わせ完了'],
                  description: 'STORY PLANETへのお問い合わせページです。お問い合わせはフォームより受け付けをしております。フォームに必要な情報を入力後「確認」ボタンよりご確認の上「送信」お願いします。',
                  keyword: 'お問い合わせ,問合せ,フォーム',
              },
          },
          {
            path: 'faq',
            component: () => import('./views/page/Guide.vue'),
            meta: {
              title: 'ご利用ガイド｜よくあるご質問｜STORY PLANET',
              pankuzu: ['ご利用ガイド'],
              description: 'STORY PLANETでのお買い物に関する情報ページです。ご注文の流れ｜お支払いについて｜領収書について｜送料について｜梱包について（ギフト包装／のし紙）｜会員サービスについて｜返品交換について｜FAQ（よくあるご質問）はこちらをご覧ください。',
              keyword: '買い物,支払い,質問,送料',
            }
          },
          {
            path: 'terms',
            component: () => import('./views/page/Terms.vue'),
            meta: {
              title: 'ご利用規約｜STORY PLANET',
              pankuzu: ['ご利用規約'],
              description: 'STORY PLANETのご利用規約ページです。【STORY PLANET】は、株式会社STORYが運営するウェブサイトです。',
              keyword: '利用規約,ストーリー,STORY',
            }
          },
          {
            path: 'privacy_policy',
            component: () => import('./views/page/PrivacyPolicy.vue'),
            meta: {
              title: 'プライバシーポリシー｜STORY PLANET',
              pankuzu: ['プライバシーポリシー'],
              description: 'STORY PLANETのプライバシーポリシーページです。個人情報の取り扱いについて｜Cookie（クッキー）の使用について【STORY PLANET】は、株式会社STORYが運営するウェブサイトです。',
              keyword: '個人情報,ストーリープラネット,STORY',
            }
          },
          {
            path: 'point_rule',
            component: () => import('./views/page/PointRule.vue'),
            meta: {
              title: 'ポイントの利用規約｜STORY PLANET',
              pankuzu: ['ポイントの利用規約'],
              description: 'STORY PLANETのポイントの利用規約ページです。ポイントの付与及び利用方法をご紹介します。【STORY PLANET】は、株式会社STORYが運営するウェブサイトです。',
              keyword: 'ポイント,使い方,ストーリー,利用規約',
            }
          },
          {
            path: 'tokushoho',
            component: () => import('./views/page/Tokushoho.vue'),
            meta: {
              title: '特定商取引法に基づく表示｜STORY PLANET',
              pankuzu: ['特定商取引法に基づく表示'],
              description: 'STORY Planetの特定商取引法に基づく表示ページです。【STORY Planet】は、株式会社STORYが運営するウェブサイトです。',
              keyword: 'ストーリープラネット,特商法,STORY,運営',
            }
          },
          {
            path: 'site_map',
            component: () => import('./views/page/SiteMap.vue'),
            meta: {
              title: 'サイトマップ',
              pankuzu: ['サイトマップ'],
              description: 'ここはSTORY Planet【新しいなにか】と出会う冒険のはじまり｜小さなモノでも、小さな体験でも「新しい」や「好き」との出会いはワクワクする瞬間。冒険が大好きなスーさんと一緒にSTORY Planetで商品をめぐる旅に、でかけよう！',
              keyword: '買い物,新しい,EC,イラスト,商品,冒険',
            }
          },
      ],
    },
    {
      path: '/item',
      name: 'Main',
      component: () => import('./views/layout/ContentLayout.vue'),
      children: [
          {
              path: 'tokusho/eitokuen',
              component: () => import('./views/page/TokushohoEitokuen.vue'),
              meta: {
                  title: '永徳園特定商取引法に基づく表示｜STORY Planet',
                  pankuzu: ['永徳園特定商取引法に基づく表示'],
                  description: '永徳園の特定商取引法に基づく表示をまとめたページです。配送料や、お支払い、商品のお届け時期などをご確認いただけます。',
                  keyword: '水なす,特商法,永徳園,送料',
              },
          },
          {
              path: 'tokusho/chaoras',
              component: () => import('./views/page/TokushohoChaoras.vue'),
              meta: {
                  title: 'CHAORAS®特定商取引法に基づく表示｜STORY Planet',
                  pankuzu: ['CHAORAS特定商取引法に基づく表示'],
                  description: 'CHAORASの特定商取引法に基づく表示ページです。配送料や、お支払い、商品のお届け時期などをご確認いただけます。',
                  keyword: 'チャオラス,手ぬぐい,てぬぐい,特商法,配送料',
              },
          },
          {
              path: 'tokusho/afurikadogs',
              component: () => import('./views/page/TokushohoAfurikaDogs.vue'),
              meta: {
                  title: 'AFURIKA DOGS特定商取引法に基づく表示｜STORY PLANET',
                  pankuzu: ['AFURIKA DOGS特定商取引法に基づく表示'],
                  description: 'AFURIKA DOGSの特定商取引法に基づく表示ページです。配送料や、お支払い、商品のお届け時期などをご確認いただけます。',
                  keyword: 'アフリカドッグス,ポロシャツ,染め体験,特商法,配送料',
              },
          },
          {
              path: 'tokusho/kuntama',
              component: () => import('./views/page/TokushohoKuntama.vue'),
              meta: {
                  title: 'くんたま王子 特定商取引法に基づく表示｜STORY PLANET',
                  pankuzu: ['くんたま王子特定商取引法に基づく表示'],
                  description: 'くんたま王子の特定商取引法に基づく表示ページです。お支払い方法や配送料、商品のお届け時期などをご確認いただけます。',
                  keyword: 'くんたま王子,燻製たまご,特商法,配送料,支払い',
              },
          },
      ],
    },
  ]
})
// https://router.vuejs.org/ja/guide/essentials/nested-routes.html
